module.exports = __webpack_public_path__ + "static/8c491a32-fe4c-4226-8d84-2bb774e34604-500.d02fde48.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/objects/8-drunkenBricklayer-pewter/8c491a32-fe4c-4226-8d84-2bb774e34604-500.jpg
// module id = 836
// module chunks = 168707334958949